import FullWidthECGPreview from './FullWidthECGPreview';

export default FullWidthECGPreview;
